import React, { useState } from "react";
import { FeedAntsLogo, burgerMenu } from "./icons";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PublicIcon from '@mui/icons-material/Public';
import HelpIcon from "@mui/icons-material/Help";
import BarChartIcon from '@mui/icons-material/BarChart';
import HubIcon from '@mui/icons-material/Hub';
import GavelIcon from '@mui/icons-material/Gavel';
import DownloadAppModal from "./DownloadAppModal";
import GroupsIcon from '@mui/icons-material/Groups';
import SettingsIcon from '@mui/icons-material/Settings';
import { useDisclosure } from "@chakra-ui/react";
import { EventTypes, trackEvent } from "../../Utils/Analytics";
import { ENV } from '../../path';

function Header() {
  const [sidebarDisplay, setsidebarDisplay] = useState(false);
    const {
      isOpen: isDownloadAppModal,
      onOpen: openDownloadAppModal,
      onClose: closeDownloadAppModal,
    } = useDisclosure();

  const handleSectionClick = (sectionTitle) =>{
    if(ENV === "prod"){
      trackEvent(EventTypes.SECTION_CLICK,{title:sectionTitle});
    }
    openDownloadAppModal();
  }

  return (
    <div>
      <div className=" flex items-center justify-between p-4 py-2 bg-white gap-4 ">
        <div className=" flex items-center gap-4">
          {sidebarDisplay ? (
            <CloseIcon
              className="text-gray-600 md:hidden"
              onClick={() => setsidebarDisplay((prev) => !prev)}
            />
          ) : (
            <img
              src={burgerMenu}
              alt="vector"
              className="cursor-pointer size-5 mx-0.5 md:hidden"
              onClick={() => setsidebarDisplay((prev) => !prev)}
            />
          )}
          <img src={FeedAntsLogo} alt="vector" className=" w-28 h-6 " />
        </div>

        <div className=" flex items-center gap-2 md:gap-6">
          <Link
            to={`/get-help`}
            className=" flex items-center gap-1 flex-nowrap">
            <HelpIcon className="text-[#008080]" />
            <h1 className="font-medium font-gilroy-semibold text-[#008080] hidden md:block ">
              Get Help
            </h1>
          </Link>

          <div className=" p-1 transition duration-200 flex items-center gap-4 rounded-3xl bg-[#F6F5FA] px-4 border border-viewMore">
            <Link to={"/all-competition"} className=" flex items-center ">
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="[@media(max-width:974px)]:w-[24px] [@media(max-width:974px)]:h-[24px]">
                <g clipPath="url(#clip0_3892_2624)">
                  <path
                    d="M8.23728 10.8394H8.73699C12.3849 10.8394 13.6792 8.65194 13.6792 6.77694C13.6787 6.26881 13.5227 5.77674 13.2381 5.38521C12.9536 4.99369 12.5581 4.72714 12.1197 4.63132C12.2075 4.42934 12.2826 4.22048 12.3442 4.00632C12.4401 3.64066 12.4589 3.25444 12.3992 2.87895C12.3395 2.50346 12.2029 2.14927 12.0005 1.84507C11.7963 1.53159 11.5301 1.27722 11.2235 1.10252C10.9169 0.927817 10.5785 0.837696 10.2356 0.839441H3.94361C3.6006 0.837913 3.26208 0.928323 2.95547 1.10335C2.64885 1.27838 2.38275 1.53312 2.1787 1.84694C1.97629 2.15115 1.8397 2.50534 1.77997 2.88083C1.72025 3.25631 1.73908 3.64253 1.83494 4.00819C1.89662 4.22235 1.97168 4.43122 2.05954 4.63319C1.62137 4.72895 1.22613 4.99523 0.941583 5.38637C0.657037 5.7775 0.500919 6.26913 0.5 6.77694C0.5 8.65194 1.79431 10.8394 5.4422 10.8394H5.94191C5.9739 11.0292 5.99044 11.2219 5.99133 11.4151V13.3394C6.00076 13.5064 5.97882 13.6737 5.92697 13.8302C5.87511 13.9867 5.79453 14.1289 5.69061 14.2472C5.58668 14.3655 5.46179 14.4572 5.32426 14.5162C5.18674 14.5752 5.03974 14.6002 4.89306 14.5894H3.7948C3.64916 14.5894 3.50948 14.6553 3.4065 14.7725C3.30352 14.8897 3.24566 15.0487 3.24566 15.2144C3.24566 15.3802 3.30352 15.5392 3.4065 15.6564C3.50948 15.7736 3.64916 15.8394 3.7948 15.8394H10.3844C10.53 15.8394 10.6697 15.7736 10.7727 15.6564C10.8757 15.5392 10.9335 15.3802 10.9335 15.2144C10.9335 15.0487 10.8757 14.8897 10.7727 14.7725C10.6697 14.6553 10.53 14.5894 10.3844 14.5894H9.28942C9.14252 14.6005 8.99524 14.5758 8.8574 14.517C8.71955 14.4581 8.59432 14.3665 8.49007 14.2482C8.38581 14.1299 8.30493 13.9876 8.25281 13.8309C8.2007 13.6742 8.17856 13.5067 8.18786 13.3394V11.4144C8.18878 11.2215 8.20532 11.029 8.23728 10.8394ZM9.13566 9.05757C10.0766 8.10886 10.8906 7.00868 11.5518 5.79194C11.617 5.82263 11.6867 5.83876 11.7572 5.83944C11.9757 5.83944 12.1852 5.93821 12.3397 6.11403C12.4941 6.28984 12.5809 6.5283 12.5809 6.77694C12.5809 8.13694 11.5711 9.58944 8.73699 9.58944H8.70624C8.83006 9.39313 8.97424 9.21455 9.13566 9.05757ZM5.4422 9.58944C2.60812 9.58944 1.59827 8.13694 1.59827 6.77694C1.59827 6.5283 1.68505 6.28984 1.83952 6.11403C1.994 5.93821 2.20351 5.83944 2.42197 5.83944C2.49265 5.83884 2.56257 5.82271 2.62789 5.79194C3.28915 7.00868 4.10316 8.10886 5.04408 9.05757C5.2053 9.21459 5.3493 9.39317 5.47295 9.58944H5.4422Z"
                    fill="#637381"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3892_2624">
                    <rect
                      width="13.1792"
                      height="15"
                      fill="white"
                      transform="translate(0.5 0.839417)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <h2 className="post-event ml-2 mr-[1%] text-primary [@media(max-width:974px)]:hidden">
                Competition
              </h2>
            </Link>
            <Link
              to={"/leaderboard"}
              className=" flex items-center flex-nowrap [@media(max-width:974px)]:hidden">
              <AnalyticsIcon className="text-[#637381] " />

              <h2 className="post-event ml-2 mr-[1%] text-primary ntest">
                LeaderBoard
              </h2>
            </Link>
          </div>
        </div>
      </div>
      {/* Menu Sidebar */}
      <div className="border border-viewMore md:hidden ">
        <ul
          className={` shadow-xl rounded-b-md  absolute transition-all z-20 ${
            sidebarDisplay ? "left-0 block" : "-left-full hidden"
          } bg-white w-[100vw] h-fit text-primary`}>
          <Link to={`/leaderboard`} onClick={() => setsidebarDisplay(false)}>
            <li className=" flex mx-[2%] my-[3%] items-center cursor-pointer ">
              <span className="mx-[3%] mr-[5%]  mt-[2%]">
                <AnalyticsIcon className="text-[#637381]" />
              </span>
              <span className="text-[#637381] mt-[2%]  ">
                {" "}
                Leader Board
              </span>
            </li>
          </Link>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer " 
          onClick={()=>handleSectionClick("statistics")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <BarChartIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              My Statistics
            </span>
          </li>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer " onClick={()=>handleSectionClick("Wirings")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <HubIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              Wirings
            </span>
          </li>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer " onClick={()=>handleSectionClick("peer-interests")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <GroupsIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              Peer Interests
            </span>
          </li>

          <Link to={`/apply-as-judge`} onClick={() => setsidebarDisplay(false)}>
          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer ">
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <GavelIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              Apply as Judge
            </span>
          </li>
          </Link>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer" onClick={()=>handleSectionClick("home")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <HomeOutlinedIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              {" "}
              Home
            </span>
          </li>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer " onClick={()=>handleSectionClick("browse-feed")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <PublicIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              Browse Feed
            </span>
          </li>

          <li className=" flex mx-[2%] my-[3%] items-center border-t border-t-gray-100 cursor-pointer " onClick={()=>handleSectionClick("settings")}>
            <span className="mx-[3%] mr-[5%]  mt-[2%]">
              <SettingsIcon className="text-[#637381]" />
            </span>
            <span className="text-[#637381] mt-[2%]  ">
              Settings
            </span>
          </li>
          
        </ul>
      </div>

      <DownloadAppModal
        isOpen={isDownloadAppModal}
        onClose={closeDownloadAppModal}
      />
    </div>
  );
}

export default Header;
